import React, { Fragment, useState } from 'react';
import Button from '../../../Button';
import Modal from '../../../common/Modal';
import Form from './form';
import { ToastContainer } from 'react-toastify';
import Dropdown from 'react-bootstrap/Dropdown';

const ShippingForm = ({ isLink, orderPackageId, defaultValue, buttonClass }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <Fragment>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Ship"
        headerText="Ship Item"
      >
        <Form orderPackageId={orderPackageId} isLink={isLink} closeModal={closeModal} defaultValue={defaultValue} />
      </Modal>

      {isLink && <Dropdown.Item onClick={openModal}>Ship</Dropdown.Item>}
      {!isLink && buttonClass && <button type="button" className={buttonClass} onClick={openModal}>Ship</button>}
      {!isLink && !buttonClass && <Button onClick={openModal}>Ship</Button>}

    </Fragment>
  )
}

export default ShippingForm;
